import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { authRedirectSave as authRedirectSaveAction } from '../actions/AuthActions';
import { notify } from '../helpers/action';
import { propBool, propStr } from '../helpers/custom-prop-types';
import { useDidMount } from '../helpers/use/useHook';
/**
 * @deprecated TS化済: src/components/functional/Link/CustomRedirect/CustomRedirect.tsx
 */
const CustomRedirect = (props) => {
    const { isSavePathForRedirect, message, to } = props;
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    useDidMount(() => {
        if (message) {
            notify(message);
        }
        if (isSavePathForRedirect) {
            dispatch(authRedirectSaveAction(pathname));
        }
    });
    return _jsx(Navigate, { replace: true, to: to });
};
CustomRedirect.propTypes = {
    isSavePathForRedirect: propBool(),
    message: propStr(),
    to: propStr().isRequired,
};
CustomRedirect.defaultProps = {
    isSavePathForRedirect: false,
    message: '',
};
export default CustomRedirect;
